module.exports = __webpack_public_path__ + "static/img/application3-2.b6bf7e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/application3-2.jpg
// module id = MXX6
// module chunks = 0